export const PRICE = "AED"

export const faqCategory = [
  { label: "General", value: "General" },
  { label: "Account", value: "Account" },
  { label: "Payment", value: "Payment" },
  { label: "Services", value: "Services" },
]


const currentYear = new Date().getFullYear();
export const globalYears = [
  { label: currentYear - 2, value: currentYear - 2 },
  { label: currentYear - 1, value: currentYear - 1 },
  { label: currentYear, value: currentYear },
  { label: currentYear + 1, value: currentYear + 1 },
];